import { ChangeEvent, FC, memo } from 'react'
import { PostcodeDistrict } from '@leadgen/models/client'
import useCallbackDebounced from '../../../../hooks/shared/useCallbackDebounced'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'

const DistrictRow: FC<{
  postcodeDistrict: PostcodeDistrict
  selected: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}> = ({ postcodeDistrict, selected, onChange }) => {
  const onClick = useCallbackDebounced(() => {
    onChange({
      target: { value: postcodeDistrict },
    } as React.ChangeEvent<HTMLInputElement>)
  }, [postcodeDistrict, onChange])
  return (
    <ListItem
      id={`district-list-item-${postcodeDistrict}`}
      onClick={onClick}
      sx={theme => ({
        [theme.breakpoints.down('sm')]: {
          paddingLeft: 1,
          paddingRight: 4,
        },
      })}
      secondaryAction={
        <Checkbox
          value={postcodeDistrict}
          edge="end"
          sx={theme => ({
            '&:hover': {
              backgroundColor: 'transparent',
            },
            [theme.breakpoints.down('sm')]: {
              paddingLeft: 0,
              paddingRight: 0,
            },
          })}
          onChange={onChange}
          checked={!!selected}
        />
      }
    >
      <ListItemText
        primary={
          <Typography
            variant={'subtitle2'}
            sx={theme => ({
              fontSize: 12,
              color: theme.palette.text.secondary,
            })}
          >
            {postcodeDistrict}
          </Typography>
        }
      />
    </ListItem>
  )
}

export default memo(DistrictRow)
